import React, {useRef, useState} from "react"
import CustomerNavbar from "../../../components/Navbars/CustomerNavbar"
import Shape from "../../../components/Shape"
import {Button, Col, Container, Input, Row,} from "reactstrap"
import SimpleFooter from "../../../components/Footers/SimpleFooter"
import {observer} from "mobx-react"
import Table, {Formatters} from '../../../components/Table'
import ReactDatetime from "react-datetime"
import moment from "moment"
import {useAppDataStore} from "../../../stores/appDataStore"
import "react-datetime/css/react-datetime.css";
import 'moment/locale/es';

const FilterBlock = ({onGenerate}) => {

  const [startDate, setStartDate] = useState(moment().startOf('month'))
  const [endDate, setEndDate] = useState(moment())
  const [user, setUser] = useState('')
  const [balanceType, setBalanceType] = useState('')

  const generate = () => {
    onGenerate(startDate, endDate, user, balanceType)
  }
  return (
    <Row>
      <Col lg={12}>
        <div className={'search-box'}>
          Reporte de transferencias de saldo
          <Row>
            <Col lg={6}>
              <label>Fecha inicial</label>
              <ReactDatetime
                locale={'es'}
                onChange={(date => setStartDate(date))}
                dateFormat={'YYYY-MM-DD'}
                initialValue={startDate.format('YYYY-MM-DD')}
                inputProps={{className: 'form-control form-control-sm'}}
                timeFormat={false}
                closeOnSelect={true}
              />
            </Col>
            <Col lg={6}>
              <label>Fecha Final</label>
              <ReactDatetime
                locale={'es'}
                onChange={(date => setEndDate(date))}
                dateFormat={'YYYY-MM-DD'}
                initialValue={endDate.format('YYYY-MM-DD')}
                inputProps={{className: 'form-control form-control-sm'}}
                timeFormat={false}
                closeOnSelect={true}
              />
            </Col>
          </Row>
          <Row>
            <Col lg={6}>
              <label>Usuario</label>
              <Input
                size="sm"
                type="text"
                onChange={e => setUser(e.target.value)}/>
            </Col>
            <Col lg={6}>
              <label>Tipo de saldo</label>
              <Input
                size="sm"
                id="exampleSelect"
                name="select"
                type="select"
                onChange={e => setBalanceType(e.target.value)}
              >
                <option value="">Principal</option>
                <option value="1">Comisiones</option>
              </Input>
            </Col>
          </Row>
          <p></p>
          <Button size={'sm'} onClick={generate}>Generar reporte</Button>
        </div>
      </Col>
    </Row>)
}

const Transfers = observer(() => {

  const appDataStore = useAppDataStore()

  const [data, setData] = useState([])

  const mainRef = useRef()

  const columns = [
    {
      field: 'id',
      maxWidth: 80,
      flex: 1,
      headerName: 'ID'
    },
    {
      field: 'description',
      flex: 1,
      headerName: 'Descripción'
    },
    {
      field: 'balanceBefore',
      maxWidth: 150,
      headerName: 'Saldo anterior',
      valueFormatter: Formatters.cash
    },
    {
      field: 'amount',
      headerName: 'Valor',
      maxWidth: 150,
      flex: 1,
      valueFormatter: Formatters.cash
    },
    {
      field: 'balanceAfter',
      maxWidth: 150,
      headerName: 'Saldo final',
      valueFormatter: Formatters.cash
    },
    {
      field: 'createdAt',
      maxWidth: 190,
      headerName: 'fecha',
      valueFormatter: Formatters.datetime
    }
  ]

  const generateReport = async (startDate, endDate, user, balanceType) => {
    let res = await appDataStore.getTransfersReport(startDate, endDate, user, balanceType)
    if (res.accounting) setData(res.accounting)
  }

  return (
    <div>
      <CustomerNavbar/>
      <main ref={mainRef}>
        <section className="section section-shaped section-lg">
          <Shape/>
          <Container className="py-lg-md">
            <FilterBlock onGenerate={generateReport}/>
            <Row>
              <Col lg={12} md={12}>
                <Table cols={columns}
                       tableName={'Reporte de transferencias'}
                       rows={data}/>
              </Col>
            </Row>
          </Container>
        </section>
      </main>
      <SimpleFooter/>
    </div>
  )
})

export default Transfers
